import heartIcon from "../assets/images/heart_logo_unity.png";
import { Link } from "react-router-dom";
const Assessments = () => {
  return (
    <div className="px-6 pt-8 lg:pb-20 md:pb-20 pb-10 relative z-50 responsive-assment">
      <div className="tab-screen">
        <div className="mb-3 flex flex-row items-center text-black responsive-top-heading relative">
          {/* Background Blur */}
          <div className="absolute inset-0 z-[0] flex justify-center">
            <div className="w-[80%] h-64 mt-7 blur-[90px] rounded-full bg-[#A7D4FF]/60"></div>
          </div>

          <div className="relative z-[10] py-8 w-full">
            <div className="bg-cardbg70 backdrop-blur-xl w-full p-6 rounded-3xl shadow-xl">
              <div className="flex justify-between items-start">
                <h1 className="text-[28px] font-bold leading-tight text-white">
                  Digital <br /> Health <br /> Screening
                </h1>

                <img
                  src={heartIcon}
                  alt="Heart Icon"
                  className="w-[120px] object-contain"
                />
              </div>

              <p className="text-[#FFFF] font-light text-[15px] leading-relaxed mt-4">
                A single, frictionless diagnostic journey combining AI-powered
                facial analysis and vocal biomarker assessment to produce
                clinically meaningful insights for Cardiac and Pulmonary health
                screening.
              </p>

              <p className="text-[#FFFF] font-light text-[15px] leading-relaxed mt-4">
                Using just a smartphone camera and microphone, the system
                simultaneously captures rPPG signals from the face and acoustic
                biomarkers from a short guided voice prompt. These two data
                streams are analyzed in real-time to generate a comprehensive
                health profile.
              </p>

              <Link to="/face-pulmo-dashboard">
                <button className="w-full mt-6 py-3 rounded-xl bg-[#7591CD] transition font-medium text-white">
                  Start Assessment
                </button>
              </Link>
            </div>

            <div className="bg-[#364560] w-full p-5 rounded-2xl mt-8 text-xs text-white/70 leading-relaxed">
              <p className="text-white font-semibold mb-2">Disclaimer :</p>
              <p>
                For investigational use only. Careplix is not a substitute for
                the clinical judgment of a health care professional. Careplix is
                intended to improve your awareness of general wellness. Careplix
                does not diagnose, treat, mitigate or prevent any disease,
                symptom, disorder or abnormal physical state. Consult with a
                health care professional or emergency services if you believe
                you may have a medical issue.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assessments;
